import { Box, Table, TableRow, TopBar } from '@sam/components';
import { TableHeader, TableKey } from '@sam/components/src/Table/Table.types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { updateSchambeckUserTableConfig, useData } from 'shared';
import { Right } from 'shared/src/userRole/UserRole.types';
import { NotAllowed } from '../../components/NotAllowed';
import { useUser } from '../../components/UserContext';
import { convertAbsenceReasonsIntoTableEntries } from '../../utils/absenceReason/AbsenceReason.utils';
import { isUserAllowedToDo } from '../../utils/user/User.utils';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

const AbsenceReasonOverview: React.FC = () => {
  const { user, updateContextUser, axios } = useUser();

  const navigate = useNavigate();
  const { t } = useTranslation();

  const { data: simpleUsers } = useData('SIMPLEUSERS_ALL', {
    config: { fallbackData: [] },
  });
  const { data: loadedReasons } = useData('ABSENCE_REASONS_ALL', {
    config: { fallbackData: [] },
  });

  const rows: TableRow[] = useMemo(
    (): TableRow[] =>
      convertAbsenceReasonsIntoTableEntries(user.right, loadedReasons, simpleUsers, navigate),
    [loadedReasons, navigate, simpleUsers, user.right],
  );
  return isUserAllowedToDo(user.right, Right.ABSENCE_REASON_OVERVIEW) ? (
    <>
      <TopBar title={t('pages.absenceReasons.overview.headline')}>
        {isUserAllowedToDo(user.right, Right.ABSENCE_REASON_CREATE) && (
          <IconComponent type={IconType.ADD} onClick={() => navigate('/absence/reason/create')} />
        )}
      </TopBar>
      <Box>
        <Table
          tableConfig={user.tableConfig?.get(TableKey.ABSENCE_REASON_OVERVIEW)}
          updateTableConfig={(updatedHeader) => {
            updateSchambeckUserTableConfig(
              axios,
              user,
              TableKey.ABSENCE_REASON_OVERVIEW,
              updatedHeader,
            ).then((updatedUser) => updatedUser && updateContextUser(updatedUser));
          }}
          rows={rows}
          header={
            t('pages.absenceReasons.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </>
  ) : (
    <NotAllowed neccessaryRight={Right.ABSENCE_REASON_OVERVIEW} />
  );
};
export default AbsenceReasonOverview;
